import PriceRepositoryInterface from '../interface-adapters/PriceRepositoryInterface';
import PriceRepository from '../repositories/PriceRepository';
import FormatPriceUseCase from '../use-cases/FormatPriceUseCase';

export default class PriceFactory {
    private static repo: PriceRepositoryInterface;
    private static formatPriceUseCase: FormatPriceUseCase;

    public static makeRepo(): PriceRepositoryInterface {
        if (!this.repo) {
            this.repo = new PriceRepository();
        }

        return this.repo;
    }

    public static makeFormatUseCase(): FormatPriceUseCase {
        if (!this.formatPriceUseCase) {
            this.formatPriceUseCase = new FormatPriceUseCase();
        }

        return this.formatPriceUseCase;
    }
}
